import { getReservationExpirationTimeLeft } from '~/components/Checkout/CheckoutPage/CheckoutPageUtils'

import { DailyOrFestivalReservation, useCheckoutContext } from '../checkoutFlow'

import { useCountdown } from './useCountdown'

export const useReservationExpirationDuration = () => {
  const { reservation } = useCheckoutContext<DailyOrFestivalReservation>()

  if (!reservation.expiresAt) return null

  return getReservationExpirationTimeLeft({
    expiresAt: reservation.expiresAt || '',
    timestamp: reservation.timestamp || '',
  })
}

export const useReservationExpirationCountdown = () => {
  const duration = useReservationExpirationDuration()
  return useCountdown({ duration, counterOn: duration !== null })
}
